/**
 * External dependencies
 */
import { RefObject } from 'react';

export const isRefObject = <T extends HTMLElement = HTMLElement>(
	element: any
): element is RefObject<T> => typeof element === 'object' && !!element.current;
